import axios from "axios";

// Instancia global de Axios apuntando al prefijo /s2k/
const apiClient = axios.create({
  baseURL: process.env.REACT_APP_API,
});

// Token guardado por usersSlice en localStorage ("userInfo")
export function getStoredToken() {
  try {
    const raw = localStorage.getItem("userInfo");
    if (!raw) return null;
    const user = JSON.parse(raw);
    return user && user.token ? user.token : null;
  } catch (err) {
    return null;
  }
}

function readHeader(headers, name) {
  if (!headers) return null;
  if (typeof headers.get === "function") return headers.get(name);
  return headers[name];
}

function writeHeader(headers, name, value) {
  if (typeof headers.set === "function") headers.set(name, value);
  else headers[name] = value;
}

// Adjunta el JWT (x-access-token) a cada petición, salvo que la llamada
// ya traiga uno explícito (p.ej. un token de otro usuario logueado).
apiClient.interceptors.request.use((config) => {
  const token = readHeader(config.headers, "x-access-token") || getStoredToken();
  if (token) writeHeader(config.headers, "x-access-token", token);
  return config;
});

export default apiClient;
